import { APP_CONFIG } from '../constants/global-variables.js';

export async function getPrivileges() {
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/getprivileges`;

    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });

        return res.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}


export async function getChildrenPrivileges(id) {
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/getprivileges/${id}`;
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}

export async function updatePrivilege(userId,status,privilegeId) {
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/addprivilege/${userId}`;
  
    try {
      const res = await axios.post(
        url,
        {
            status: status,
            privilege: privilegeId 
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      return res.data.data;
    } catch (err) {
      console.log("Error getting documents");
    }
}




export async function updatePercentage(single_percentage,double_percentage,triple_percentage,userId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updatepercentage/${userId}`;

  try {
    const res = await axios.post(
      url,
      {
          single_percentage: single_percentage,
          double_percentage: double_percentage, 
          triple_percentage: triple_percentage,
          partner_type : 'turnover_percentage'
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}


export async function updateRepeatedBet(userId, repeatedValue) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updatenumberofrepeatedbets/${userId}`;

  try {
    const res = await axios.post(
      url,
      {
          repeat_value: repeatedValue
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}



export async function updateCashout(cashoutData,userId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updatecashout/${userId}`;

  try {
    const res = await axios.post(
      url,
      {
          can_cashout: cashoutData
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function updatemaxbetpay(min_bet,max_bet,max_pay,userId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updatemaxbetpay/${userId}`;

  try {
    const res = await axios.post(
      url,
      {
          min_bet: min_bet,
          max_bet: max_bet,
          max_pay: max_pay
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}



export async function updatesumonhold(price,userId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updatesumonhold/${userId}`;

  try {
    const res = await axios.post(
      url,
      {
          sum_on_hold: price
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}


